export default "__VITE_ASSET__ff376592__"